import React from "react"
import ByDate from "./views/Review/ByDate";
import Trimester from "./views/Review/Trimester";
import RoomNights from "./views/Review/RoomNights";
import Adr from "./views/Review/Adr";
import Revenue from "./views/Review/Revenue";
import RevPar from "./views/Review/RevPar";
import Segment from "./views/Review/Segment";
import Channel from "./views/Review/Channel";
import FiltersActive from "./../../../components/FiltersActive";
import ByDatePickup from "./views/Pickup/ByDate";
import OccupancyPickup from "./views/Pickup/OccupancyPickup";
import PacePickup from "./views/Pickup/PacePickup";
import TotalPickup from "./views/Pickup/TotalPickup";
import CxlPickup from "./views/Pickup/CxlPickup";
import NetPickup from "./views/Pickup/NetPickup";
import SegmentPickup from "./views/Pickup/Segment";
import ChannelPickup from "./views/Pickup/Channel";
import { production_chart } from "./widgets/Charts";
import ReactEcharts from "echarts-for-react";
import { 
    latest as API_URL, 
    host as ROOT_DIR 
} from "../../../config/api";

import { Icon, Tabs } from 'antd';

import { isActiveSlide, positionLeft, panels } from "../../../config/Helpers";
export const api = { baseUrl : API_URL + "dynamic-request" };

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active_slide : {}, 
            slides : {},
            slides_component : "",
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : false,
            filters_channels : [],
            filters_channels_aux : [],
            hidden_wdg_time : "show-widget complete",
            hidden_wdg_room_nights : "show-widget complete",
            hidden_wdg_adr : "show-widget complete",
            hidden_wdg_revenue : "show-widget complete",
            hidden_wdg_revpar : "show-widget complete",
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive',
            panels : panels(),
            pickup_years_future : [],
            review_table_filter : "market"
        }
        this.setSegments = this.setSegments.bind(this);
        this.getChannels = this.getChannels.bind(this);
        this.activeFiltersMS = this.activeFiltersMS.bind(this);
        this.activeSegment = this.activeSegment.bind(this);
        this.activeWidget = this.activeWidget.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.setDefaultValuesModule = this.setDefaultValuesModule.bind(this);
        this.callMainRequest = this.callMainRequest.bind(this);
        this.getResetValues = this.getResetValues.bind(this);
    }
    setDefaultValuesModule(update = false, params = {}){
        let self = this;
        if(this.state.active_slide.key === "pickup"){
            self._widgetByDatePickup.setState(self._widgetByDatePickup.getDefaultValues());
            self._widgetSegmentPickup.setState(self._widgetSegmentPickup.getDefaultValues());
            self.callMainRequest(false, params);
        }else{
            if(Object.keys(params).length > 0){
                self._widgetByDate.setState(self._widgetByDate.getDefaultIntervalTime());
                self._widgetSegment.setState(self._widgetSegment.getDefaultIntervalTime());
            }else{
                self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
                self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
            }
            self.setState(self.getDefaultValues(), () => {
                this.callMainRequest(false, params)
            });
        }
    }
    callMainRequest(pickup = false, params = {}){
        if(pickup === true){
            this.props.app._widgetFiltersTime.setRangeCustom("pickup")
        }else{
            this.props.app.mainRequest(params)
        }
    }
    getOptionTypeBar = (chart) => {
        let self = this;
        if(Object.keys(this.state.chart_pickup).length > 0){
            let response = this.state.chart_pickup[self.state.active_chart_type.value];
            let option = production_chart(response);
            option["tooltip"] = {
                position: 'inside',
                triggerOn : 'click',
                alwaysShowContent : false,
                transitionDuration : 0,
                formatter: function (params, ticket, callback) {
    
                    /*axios.get(api.baseUrl, {
                        params : self.props.app.currentFilters() 
                    }).then(result => {
                        callback(ticket, "holaaa")
                    }).catch(error => { throw error; })
    
                    return "Cargando";*/
                }
            }
            return option;
        }else{
            return {}
        }
    }
    getDefaultValues(){
        return {
            slides : {},
            statics: [],
            statics_segments: [],
            statics_channels: [],
            statics_trimester: [],
            statics_aux: [],
            statics_segments_aux: [],
            statics_channels_aux: [],
            total_widgets: [],
            total_widgets_channels: [],
            filters_segment: false,
            filters_channels: [],
            filters_channels_aux: [],
            hidden_wdg_time: "show-widget complete",
            hidden_wdg_room_nights: "show-widget complete",
            hidden_wdg_adr: "show-widget complete",
            hidden_wdg_revenue: "show-widget complete",
            hidden_wdg_revpar: "show-widget complete",
            hide_widget_trimester: "hide-widget",
            key_filter_channel: null,
            filter_ms_active: "inactive",
            filter_month_active: "inactive",
            filter_trimester_active: "inactive",
            filter_segment_active: "inactive",
            request_status: "",
            key_trimester: "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
    }
    getResetValues(){
        return {
            active_slide : {}, 
            slides : {},
            statics: [],
            statics_segments: [],
            statics_channels: [],
            statics_trimester: [],
            statics_aux: [],
            statics_segments_aux: [],
            statics_channels_aux: [],
            total_widgets: [],
            total_widgets_channels: [],
            filters_segment: false,
            filters_channels: [],
            filters_channels_aux: [],
            hidden_wdg_time: "show-widget complete",
            hidden_wdg_room_nights: "show-widget complete",
            hidden_wdg_adr: "show-widget complete",
            hidden_wdg_revenue: "show-widget complete",
            hidden_wdg_revpar: "show-widget complete",
            hide_widget_trimester: "hide-widget",
            key_filter_channel: null,
            filter_ms_active: "inactive",
            filter_month_active: "inactive",
            filter_trimester_active: "inactive",
            filter_segment_active: "inactive",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
    }
    setSegments(segments, key_time, filt) {
        let self = this;
        const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
        if (segments !== null) {
            self.setState({
                filters_segment: true,
                filter_month_active: status,
                key_time: filt
            }, function () {
                //self.props.app.mainRequest({}, true);
                self.props.app.forceUpdate();
            })
        } else {
            self.setState({
                filters_segment: false,
                segments: [],
                filter_month_active: status,
                filter_segment_active: "inactive",
                statics_channels: {},
                segmentActive : {}
            }, function(){
                if(this.state.active_slide.key === "summary"){
                    self._widgetSegment.setState({
                        segmentActive : {}
                    }, function(){
                        self.props.app.forceUpdate();
                    })
                }else{
                    self._widgetSegmentPickup.setState({
                        segmentActive : {}
                    }, function(){
                        self.props.app.forceUpdate();
                    })
                }
            })
        }
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    getChannels(status, segmentActive) {
        let self = this;
        if (status === 'active') {
            self.setState({
                statics_channels: Object.assign({}, self.state.filters_channels),
                filter_segment_active : "active",
                segmentActive : segmentActive
            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
                
            })
        } else {
            self.setState({
                statics_channels : {},
                filter_segment_active : "inactive",
                segmentActive : {}

            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
            })
        }
    }

    activeFiltersMS(status) {
        this.setState({ filter_ms_active: status })
    }

    activeSegment(status) {
        if (status === "inactive") {
            this.setState({
                filters_channels: [],
                statics_channels: []
            });
        }
        this.setState({
            filter_segment_active: status
        })
    }
    activeWidget(type) {
        let status;
        let self = this;
        this.setState(function (prevState) {

            if (type === "time") {
                status = { hidden_wdg_time: prevState.hidden_wdg_time === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "room-nights") {
                status = { hidden_wdg_room_nights: prevState.hidden_wdg_room_nights === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "adr") {
                status = { hidden_wdg_adr: prevState.hidden_wdg_adr === "hide-widget complete" ? "show-widget" : "hide-widget" }
            } else if (type === "revenue") {
                status = { hidden_wdg_revenue: prevState.hidden_wdg_revenue === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }else if (type === "revpar") {
                status = { hidden_wdg_revpar: prevState.hidden_wdg_revpar === "hide-widget complete" ? "show-widget" : "hide-widget" }
            }
            return status;
        })
        setTimeout(() => {
            if (type === "time") {
                self.setState({
                    hidden_wdg_time: self.state.hidden_wdg_time === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "room-nights") {
                self.setState({
                    hidden_wdg_room_nights: self.state.hidden_wdg_room_nights === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "adr") {
                self.setState({
                    hidden_wdg_adr: self.state.hidden_wdg_adr === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            } else if (type === "revenue") {
                self.setState({
                    hidden_wdg_revenue: self.state.hidden_wdg_revenue === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }else if (type === "revpar") {
                self.setState({
                    hidden_wdg_revpar: self.state.hidden_wdg_revpar === "hide-widget" ? "hide-widget complete" : "show-widget complete"
                });
            }
        }, 200);
    }
    componentWillReceiveProps(props){
        let response = props.app.state.review_response_request
        let self = this;
        if(Object.keys(response).length > 0){
            self.setState(function (prevState) {                
                let results = {}
                if (self.state.filters_segment === true) {
                    let filters_channels_aux = {};
                    Object.keys(response.month_widgets).map(function(key) {
                        let rr = response.month_widgets[key]['segments'];
                        filters_channels_aux[key] = {}
                        Object.keys(rr).map(function(key_two) {
                            filters_channels_aux[key][key_two] = {};
                            if(key_two !== "totals"){
                                if(rr[key_two]["channels"] !== undefined){
                                    let rr2 = rr[key_two]["channels"]
                                    Object.keys(rr2).map(function(key_three){
                                        filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                    });
                                }
                            }else{
                                filters_channels_aux[key][key_two] = rr[key_two]
                            }
                        });
                    })

                    results = {
                        chart_pickup : response.chart_pickup,
                        filters_channels: filters_channels_aux,
                        statics_segments_aux: response.month_widgets,
                        statics_segments: response.month_widgets,
                        pickup_years_future : (response.pickup_years_future !== undefined) ? response.pickup_years_future : ""
                        //total_widgets: response.total_widgets
                    }
                } else {
                    
                    results = {
                        chart_pickup : response.chart_pickup,
                        statics_channels: [],
                        statics_segments: [],
                        statics_trimester: [],
                        statics_aux: response.month_widgets,
                        statics: response.month_widgets,
                        total_widgets: response.total_widgets,
                        pickup_years_future : (response.pickup_years_future !== undefined) ? response.pickup_years_future : ""
                    }
                    
                }
                return results;
            }, function () {
                let filt;
                if(this.props.app.state.panel === "review"){
                    if(this.state.active_slide.key === "summary"){
                        filt = self._widgetByDate.state.current_key_time;
                    }else{
                        filt = self._widgetByDatePickup.state.current_key_time;
                    }
                    let state_statics = Object.assign({}, self.state.statics);
                
                    Object.keys(state_statics).map(function(key){
                        if(filt[key] !== undefined){
                            state_statics[key].state = "active";
                        }else{
                            state_statics[key].state = "inactive";
                        }
                    })
                    self.setState({
                        statics_aux : state_statics,
                        statics : state_statics,
                    },function(){
                        if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegment.state.segmentActive)
                        }
                        if(Object.keys(self._widgetSegmentPickup.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegmentPickup.state.segmentActive)
                        }
                    })
                }
            })
        }

        let panel = "review", 
        panel_dashboards = self.props.app.state.mode_report._dashboards_select,
        panels = this.state.panels;
        this.state.slides_component = Object.keys(panels).map((key) => {
            let index = -1;
            if(panels[key].value === panel){
                let dashboards = panels[key].dashboards;
                return (Object.keys(dashboards).map((key_aux) => {

                    //if(dashboards[key_aux].name === 'Pickup'){ return ;}
                    let dashboard_include = false;
                    console.log(self.props.app.state.mode_report.status,self.props.app.state.mode_report._is_share)
                    if(self.props.app.state.mode_report.status === true && self.props.app.state.mode_report._is_share === true){
                        Object.keys(panel_dashboards).map((key) => {
                            let _decode = JSON.parse(panel_dashboards[key]);
                            if(_decode._dashboard === dashboards[key_aux].value){
                                dashboard_include = true
                            }
                        })
                    }else{
                        dashboard_include = true
                    }
                    if(dashboard_include === true){
                        index++;
                        if(index === 0 && self.state.active_slide.key === undefined){
                            self.state.active_slide.key = dashboards[key_aux].value
                            self.state.active_slide.index = index
                        }
                        return (
                            <div 
                                className={isActiveSlide(self.state.active_slide.key, dashboards[key_aux].value)} 
                                onClick={self.activeSlide.bind(self, { key: dashboards[key_aux].value, index : index})}>
                                <span className="title">{dashboards[key_aux].name}</span>
                            </div>
                        )
                    }
                }))
            }
        })
    }
    activeSlide(slide){

        this._widgetSegment.state.segmentActive = {}
        this._widgetSegmentPickup.state.segmentActive = {}
        this.setState({
            active_slide : slide
        }, function(){
            this.state.segmentActive = {};
            if(this.state.active_slide.key === "pickup"){
                this.props.app.state._params_module.pickup = 1;
                this.props.app.setState({
                    _params_module : {
                        pickup : 1
                    },
                    type_pickup : 'present'
                })
                this.setDefaultValuesModule(true);
            }else{
                this.props.app.state._params_module.pickup = 0;
                this.props.app.getInitialStatics('reset-dates', 'present')
            }
        })
    }
    activeChartType(item){
        this.setState({
            active_chart_type : item
        }, function(){

        })
    }
    chartTypes(){
        let self = this;
        const types = [
            { key : "Month", value : "by_month" },
            { key : "Week", value : "by_week" },
            { key : "Day", value : "by_day" }
        ];
        
        let chart_types = types.map((item, index) => (
            <div className={"chart-type-select " + (item.value === self.state.active_chart_type.value ? "active" : "") } key={"list-chart-type-"+index} onClick={self.activeChartType.bind(self, item)}>
                <span children={item.key} />
            </div>
        ))
        return chart_types;
    }

    render() {
        const TabPane = Tabs.TabPane;
        if(this.props.app.state.panel === "review"){
            return (
                <div className="layout">
                    <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "review" ? "hide" : "")}>
                        <div className="bkg-stars">
                            <span 
                                className="figure-1"
                                style={{
                                    background : 'url(' + ROOT_DIR + "uploads/" + this.props.app.state.subdomain + "/logo_old.svg" + ') center center no-repeat',
                                    backgroundSize : 300
                                }} 
                            ></span>
                        </div>
                    </div>
                    <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "summary", "main-slide")}>
                        <div className="table-split review-table">
                            <ByDate
                                statics={this.state.statics}
                                statics_segments={this.state.statics_segments}
                                total_widgets={this.state.total_widgets}
                                activeFiltersMS={this.activeFiltersMS}
                                activeSegment={this.activeSegment}
                                setSegments={this.setSegments}
                                filters_segment={this.state.filters_segment}
                                widgetSegment={this._widgetSegment}
                                getInitialStatics={this.props.app.getInitialStatics}
                                hidden_wdg_time={this.state.hidden_wdg_time}
                                activeWidget={this.activeWidget}
                                current_year={this.props.app.state.current_year}
                                past_year={this.props.app.state.past_year}
                                view_results={this.props.app.state.view_results}
                                request_status={this.state.request_status}
                                layout={this}
                                app={this.props.app}
                                ref={(child) => { this._widgetByDate = child; }}
                            />
                            <div className={"container-aux " + this.state.filter_ms_active}>
                                <Segment
                                    ref={(child) => { this._widgetSegment = child; }}
                                    statics={this.state.statics}
                                    statics_segments={this.state.statics_segments}
                                    filters_segment={this.state.filters_segment}
                                    filter_month_active={this.state.filter_month_active}
                                    getChannels={this.getChannels}
                                    request_status={this.state.request_status}
                                    activeSegment={this.activeSegment}
                                    layout={this}
                                    app={this.props.app}
                                />
                                <Channel
                                    filter_segment_active={this.state.filter_segment_active}
                                    statics={this.state.statics}
                                    filters_channels={this.state.filters_channels}
                                    current_filter_channel={this.props.app.state.current_filter_channel}
                                    key_filter_channel={this.state.key_filter_channel}
                                    skipFilterChannel={this.props.app.skipFilterChannel}
                                    skip_channels={this.props.app.state.skip_channels}
                                    request_status={this.state.request_status}
                                    app={this.props.app}
                                    layout={this}
                                    ref={(child) => { this._widgetChannel = child; }}
                                />
                            </div>
                            <RoomNights
                                statics={this.state.statics}
                                statics_segments={this.state.statics_segments}
                                statics_channels={this.state.statics_channels}
                                statics_trimester={this.state.statics_trimester}
                                total_widgets={this.state.total_widgets}
                                total_widgets_channels={this.state.total_widgets_channels}
                                hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                request_status={this.state.request_status}
                                activeWidget={this.activeWidget}
                                filter_by_pace={this.props.app.state.filter_by_pace}
                                app={this.props.app}
                                layout={this}
                                ref={(child) => { this._widgetRoomNights = child; }}
                            />
                            <Adr
                                statics={this.state.statics}
                                statics_segments={this.state.statics_segments}
                                statics_channels={this.state.statics_channels}
                                statics_trimester={this.state.statics_trimester}
                                total_widgets={this.state.total_widgets}
                                total_widgets_channels={this.state.total_widgets_channels}
                                hidden_wdg_adr={this.state.hidden_wdg_adr}
                                request_status={this.state.request_status}
                                activeWidget={this.activeWidget}
                                filter_by_pace={this.props.app.state.filter_by_pace}
                                app={this.props.app}
                                layout={this}
                                ref={(child) => { this._widgetAdr = child; }}
                            />
                            <Revenue
                                statics={this.state.statics}
                                statics_segments={this.state.statics_segments}
                                statics_channels={this.state.statics_channels}
                                statics_trimester={this.state.statics_trimester}
                                total_widgets={this.state.total_widgets}
                                total_widgets_channels={this.state.total_widgets_channels}
                                hidden_wdg_revenue={this.state.hidden_wdg_revenue}
                                request_status={this.state.request_status}
                                activeWidget={this.activeWidget}
                                filter_by_pace={this.props.app.state.filter_by_pace}
                                app={this.props.app}
                                layout={this}
                                ref={(child) => { this._widgetRevenue = child; }}
                            />

                            <RevPar
                                app={this.props.app}
                                filter_by_pace={this.props.app.state.filter_by_pace}
                                layout={this}
                                ref={(child) => { this._widgetRevPar = child; }}
                            />
                        </div>

                        <div className={"hidden-widgets "}>
                            <span className={"wdg time " + (this.state.hidden_wdg_time !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"time")}>
                                <div className="opt-w">
                                    <span className="">PERIODICITY</span> <i className="fa fa-eye"></i>
                                </div>
                            </span>
                            <span className={"wdg room-nights " + (this.state.hidden_wdg_room_nights !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"room-nights")}>
                                <div className="opt-w">
                                    <span className="">R/N</span> <i className="fa fa-eye"></i>
                                </div>
                            </span>
                            <span className={"wdg adr " + (this.state.hidden_wdg_adr !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"adr")}>
                                <div className="opt-w">
                                    <span className="">ADR</span> <i className="fa fa-eye"></i>
                                </div>
                            </span>
                            <span className={"wdg revenue " + (this.state.hidden_wdg_revenue !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revenue")}>
                                <div className="opt-w">
                                    <span className="">REVENUE</span> <i className="fa fa-eye"></i>
                                </div>
                            </span>
                            <span className={"wdg revpar " + (this.state.hidden_wdg_revpar !== "hide-widget complete" ? "hide-widget" : null)} onClick={this.activeWidget.bind(this,"revpar")}>
                                <div className="opt-w">
                                    <span className="">REVPAR</span> <i className="fa fa-eye"></i>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div style={positionLeft(1, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "pickup", "main-slide")}>
                        
                     
                                <div className="table-split">
                                    <ByDatePickup
                                        statics={this.state.statics}
                                        total_widgets={this.state.total_widgets}
                                        activeFiltersMS={this.activeFiltersMS}
                                        activeSegment={this.activeSegment}
                                        setSegments={this.setSegments}
                                        filters_segment={this.state.filters_segment}
                                        widgetSegment={this._widgetSegment}
                                        getInitialStatics={this.props.app.getInitialStatics}
                                        hidden_wdg_time={this.state.hidden_wdg_time}
                                        activeWidget={this.activeWidget}
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        view_results={this.props.app.state.view_results}
                                        request_status={this.state.request_status}
                                        layout={this}
                                        app={this.props.app}
                                        is_history={false}
                                        ref={(child) => { this._widgetByDatePickup = child; }}
                                    />
                                    <div className={"container-aux " + this.state.filter_ms_active}>
                                        <SegmentPickup
                                            ref={(child) => { this._widgetSegmentPickup = child; }}
                                            statics={this.state.statics}
                                            statics_segments={this.state.statics_segments}
                                            filters_segment={this.state.filters_segment}
                                            filter_month_active={this.state.filter_month_active}
                                            getChannels={this.getChannels}
                                            request_status={this.state.request_status}
                                            activeSegment={this.activeSegment}
                                            layout={this}
                                            app={this.props.app}
                                        />
                                        <ChannelPickup
                                            filter_segment_active={this.state.filter_segment_active}
                                            statics={this.state.statics}
                                            filters_channels={this.state.filters_channels}
                                            current_filter_channel={this.props.app.state.current_filter_channel}
                                            key_filter_channel={this.state.key_filter_channel}
                                            skipFilterChannel={this.props.app.skipFilterChannel}
                                            skip_channels={this.props.app.state.skip_channels}
                                            request_status={this.state.request_status}
                                            app={this.props.app}
                                            layout={this}
                                            ref={(child) => { this._widgetChannelPickup = child; }}
                                        />
                                    </div>
                                    <OccupancyPickup
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        statics={this.state.statics}
                                        statics_segments={this.state.statics_segments}
                                        statics_channels={this.state.statics_channels}
                                        statics_trimester={this.state.statics_trimester}
                                        total_widgets={this.state.total_widgets}
                                        total_widgets_channels={this.state.total_widgets_channels}
                                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                        request_status={this.state.request_status}
                                        activeWidget={this.activeWidget}
                                        filter_by_pace={this.props.app.state.filter_by_pace}
                                        app={this.props.app}
                                        layout={this}
                                        ref={(child) => { this._widgetOccupancyPickup = child; }}
                                    />
                                    <PacePickup
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        statics={this.state.statics}
                                        statics_segments={this.state.statics_segments}
                                        statics_channels={this.state.statics_channels}
                                        statics_trimester={this.state.statics_trimester}
                                        total_widgets={this.state.total_widgets}
                                        total_widgets_channels={this.state.total_widgets_channels}
                                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                        request_status={this.state.request_status}
                                        activeWidget={this.activeWidget}
                                        filter_by_pace={this.props.app.state.filter_by_pace}
                                        app={this.props.app}
                                        layout={this}
                                        ref={(child) => { this._widgetPacePickup = child; }}
                                    />
                                    <TotalPickup
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        statics={this.state.statics}
                                        statics_segments={this.state.statics_segments}
                                        statics_channels={this.state.statics_channels}
                                        statics_trimester={this.state.statics_trimester}
                                        total_widgets={this.state.total_widgets}
                                        total_widgets_channels={this.state.total_widgets_channels}
                                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                        request_status={this.state.request_status}
                                        activeWidget={this.activeWidget}
                                        filter_by_pace={this.props.app.state.filter_by_pace}
                                        app={this.props.app}
                                        layout={this}
                                        ref={(child) => { this._widgetTotalPickup = child; }}
                                    />

                                    <CxlPickup
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        statics={this.state.statics}
                                        statics_segments={this.state.statics_segments}
                                        statics_channels={this.state.statics_channels}
                                        statics_trimester={this.state.statics_trimester}
                                        total_widgets={this.state.total_widgets}
                                        total_widgets_channels={this.state.total_widgets_channels}
                                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                        request_status={this.state.request_status}
                                        activeWidget={this.activeWidget}
                                        filter_by_pace={this.props.app.state.filter_by_pace}
                                        app={this.props.app}
                                        layout={this}
                                        ref={(child) => { this._widgetCxlPickup = child; }}
                                    />
                                    <NetPickup
                                        current_year={this.props.app.state.current_year}
                                        past_year={this.props.app.state.past_year}
                                        statics={this.state.statics}
                                        statics_segments={this.state.statics_segments}
                                        statics_channels={this.state.statics_channels}
                                        statics_trimester={this.state.statics_trimester}
                                        total_widgets={this.state.total_widgets}
                                        total_widgets_channels={this.state.total_widgets_channels}
                                        hidden_wdg_room_nights={this.state.hidden_wdg_room_nights}
                                        request_status={this.state.request_status}
                                        activeWidget={this.activeWidget}
                                        filter_by_pace={this.props.app.state.filter_by_pace}
                                        app={this.props.app}
                                        layout={this}
                                        ref={(child) => { this._widgetNetPickup = child; }}
                                    />
                                </div>
                        
                       {/* <div className={"datagrid-widget chart-pickup  "}>
                            <div className="container-fluid">
                                <div className="row header-widget">
                                    <div className="col-md-12 options-widget">
                                        <span className="title">PRODUCTION</span>
                                        <div className="chart-types">
                                            {this.chartTypes()}
                                        </div>
                                    </div>
                                </div>
                                <div className="current-values">
                                    <div className="row">
                                        <div className="col-md-12 datagrid-list">
                                            <div className="group-years-query">
                                                <span> <span className="current-year" /> {this.props.app.state.past_year}</span>
                                                <span> <span className="last-year" /> {this.props.app.state.current_year}</span>
                                            </div>
                                            <ReactEcharts
                                                option={(this.props.app.state.panel === "review" && this.state.active_slide.key === "pickup") ? this.getOptionTypeBar("data_reserves_production") : {} }
                                                notMerge={true}
                                                lazyUpdate={true}
                                                theme={"theme_name"}
                                                
                                                onChartReady={this.onChartReadyCallback}
                                            />
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>  */}
                    </div>
                    <div className={"slide-keys " + (this.props.app.state.panel !== "review" ? "hide" : "") + " " + this.props.app.state.status_sidebar}>
                        <div className="tabs">
                            <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}><Icon type="ellipsis" theme="outlined" /> DASHBOARDS </div>
                            <div className={this.state.tab_filters + this.props.app.hasFilters()} onClick={this.activeFiltersTab.bind(this)}><Icon type="filter" theme="outlined" /> FILTERS</div>
                        </div>
                        <div className={"filters-tab " + this.state.tab_filters}>
                            <FiltersActive 
                                app={this.props.app} 
                                ref={(FiltersActive) => { this._FiltersActive = FiltersActive; }}
                            />
                        </div>
                        <div 
                            className={"content-submodules " + this.state.tab_submodule} 
                            children={this.state.slides_component} />
                    </div>
                </div>
            )
        }else{
            return (<div></div>)
        }
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/Layout.js